import { motion } from "framer-motion";
import "./GlassyButton.css";

export default function GlassyButton({ children, onClick, className = "", as = "button" }) {
    const Comp = as;
    return (
        <motion.div whileTap={{ scale: 0.98 }} className={`glassy-wrap ${className}`}>
            <Comp className="glassy-btn" onClick={onClick}>
                {/* Градиентное кольцо (бордер) */}
                <span className="glassy-ring" aria-hidden="true" />
                {/* Центр с твоим фоном и бликами */}
                <div className="glassy-inner">
                    <span className="blob"></span>
                    <span className="blob"></span>
                    <span className="blob"></span>
                </div>
                {/* Текст */}
                <span className="glassy-label">{children}</span>
            </Comp>
        </motion.div>
    );
}
